import React, { Component } from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import { Grid } from "semantic-ui-react";
import Carousel, { consts } from "react-elastic-carousel";
import PriceDisplay from "../../containers/PriceDisplay";
import AddonCarousel from "../../components/AddonCarousel/AddonCarousel";
import FormDropdown from "../common/Form/FormDropdown";
import { Header } from "../../components/common";
import Button from "../../components/Carousel/Button/Button";
import styles from "./styles.less";

class AddonCarouselGroup extends Component {
  OnAddonRoomChange = value => {
    const { onAddonRoomChanged } = this.props;
    onAddonRoomChanged(value);
  };

  onAddonIncrementClick = (addonCode, msg) => {
    const { onAddonIncrementClick } = this.props;
    onAddonIncrementClick(addonCode, msg);
  };

  renderArrows = ({ type, onClick }) => {
    const { isRtl, isIE } = this.props;
    let pointer;
    if (isRtl) {
      pointer = type === consts.NEXT ? "〉" : "〈";
    } else {
      pointer = type === consts.NEXT ? "〈" : "〉";
    }
    return (
      <Button
        onClick={onClick}
        type={type.toLowerCase()}
        isRtl={isRtl}
        isIE={isIE}
      >
        {pointer}
      </Button>
    );
  };

  renderAddonsRoomsList = () => {
    const {
      titles,
      orderSummary,
      isRtl,
      addonsCurosselRoomNumber,
      isMobileView
    } = this.props;
    let value = addonsCurosselRoomNumber;

    // map options with room number
    const modifiedOrderSummery =
      orderSummary &&
      orderSummary.map(os => ({
        ...os,
        label: `${titles.Room} ${os.value + 1}: ${os.label}`
      }));

    if (
      !value &&
      value != 0 &&
      modifiedOrderSummery &&
      modifiedOrderSummery.length > 0
    ) {
      value = modifiedOrderSummery[0].value;
    }
    return (
      <Grid.Column>
        <FormDropdown
          name={"currentAddonRoom"}
          label={titles.AddTreatment}
          onChange={this.OnAddonRoomChange}
          options={modifiedOrderSummery}
          value={value}
          fullLength={false}
          searchable={false}
          customValidation={titles.ThisFieldIsMust}
          isRtl={isRtl}
          className={styles.addonRoomSelector}
          labelClassName={styles.addonRoomSelectorLabel}
          isMobileView={isMobileView}
        />
      </Grid.Column>
    );
  };

  renderCarousel = itemsToShow => {
    const {
      addonsByPaxIndex,
      isRtl,
      selectedAddonsGroup,
      onShowAddonDetailsClick,
      titles,
      isMobileView,
      showMessage
    } = this.props;

    return (
      <Carousel
        isRTL={isRtl}
        pagination={false}
        showArrows={true}
        renderArrow={this.renderArrows}
        itemsToShow={itemsToShow}
        ref={ref => (this.carousel = ref)}
      >
        {addonsByPaxIndex &&
          addonsByPaxIndex.map((addon, i) => (
            <PriceDisplay
              key={i}
              price={addon.price}
              currentCurrencyCode={addon.currencyCode}
              fallBackCurrencySymbol={addon.currency}
            >
              {convertedPrice => (
                <AddonCarousel
                  {...addon}
                  price={convertedPrice}
                  amount={selectedAddonsGroup[addon.id] || 0}
                  onIncrement={this.onAddonIncrementClick}
                  onShowAddonDetailsClick={onShowAddonDetailsClick}
                  isRtl={isRtl}
                  titles={titles}
                  isMobileView={isMobileView}
                  showMessage={showMessage}
                />
              )}
            </PriceDisplay>
          ))}
      </Carousel>
    );
  };

  renderAddonsNoCarousel = () => {
    const {
      addonsByPaxIndex,
      isRtl,
      selectedAddonsGroup,
      onShowAddonDetailsClick,
      titles,
      isMobileView,
      showMessage
    } = this.props;

    return (
      <div
        className={styles.noCarouselAddonsWrapper}
        ref={ref => (this.carousel = ref)}
      >
        {addonsByPaxIndex &&
          addonsByPaxIndex.map((addon, i) => (
            <PriceDisplay
              key={i}
              price={addon.price}
              currentCurrencyCode={addon.currencyCode}
              fallBackCurrencySymbol={addon.currency}
            >
              {convertedPrice => (
                <AddonCarousel
                  {...addon}
                  price={convertedPrice}
                  amount={selectedAddonsGroup[addon.id] || 0}
                  onIncrement={this.onAddonIncrementClick}
                  onShowAddonDetailsClick={onShowAddonDetailsClick}
                  isRtl={isRtl}
                  titles={titles}
                  isMobileView={isMobileView}
                  showMessage={showMessage}
                />
              )}
            </PriceDisplay>
          ))}
      </div>
    );
  };

  render() {
    const {
      addonsByPaxIndex,
      isRtl,
      isMobileView,
      paxList,
      titles
    } = this.props;
    const itemsToShow = isMobileView ? 1 : 5;
    const showCarousel =
      addonsByPaxIndex && addonsByPaxIndex.length > itemsToShow;
    const showAddonRoomsList = paxList && paxList.length > 1;
    return (
      <div className={styles.addonsWrapper}>
        <div className={styles.addonsCarouselHeader}>
          <Grid.Row>
            <Grid.Column width={16}>
              <Header
                className={cx(styles.addonsHeader, {
                  [styles.rtl]: isRtl
                })}
                isRtl={isRtl}
                text={titles.UpgradeYouStay}
                isMobileView={isMobileView}
                noSidePadding={true}
                //noPadding={showAddonRoomsList ? true : false}
              />
            </Grid.Column>
          </Grid.Row>
        </div>
        {showAddonRoomsList && (
          <Grid.Column width={16}>
            <div className={styles.addonsRoomsList}>
              {this.renderAddonsRoomsList()}
            </div>
          </Grid.Column>
        )}
        <Grid.Column
          width={16}
          className={cx(styles.carousel, {
            [styles.rtl]: isRtl
          })}
        >
          {showCarousel
            ? this.renderCarousel(itemsToShow)
            : this.renderAddonsNoCarousel()}
        </Grid.Column>
      </div>
    );
  }
}

AddonCarouselGroup.propTypes = {
  addonsByPaxIndex: PropTypes.array,
  isRtl: PropTypes.bool,
  isIE: PropTypes.bool,
  isMobileView: PropTypes.bool,
  selectedAddonsGroup: PropTypes.object,
  onShowAddonDetailsClick: PropTypes.func,
  paxList: PropTypes.array,
  titles: PropTypes.object,
  orderSummary: PropTypes.array,
  onAddonIncrementClick: PropTypes.func,
  onAddonRoomChanged: PropTypes.func,
  addonsCurosselRoomNumber: PropTypes.number,
  showMessage: PropTypes.func
};

export default AddonCarouselGroup;



// WEBPACK FOOTER //
// ./src/components/AddonCarouselGroup/AddonCarouselGroup.js